const ITEMS = [
  "Plâtrerie",
  "Peinture",
  "Isolation",
  "Stucs & Enduits",
  "Moulures",
  "Façade",
  "Genève",
  "20+ ans",
  "Famille Demiri",
];

const HouseGlyph = ({ inverted }) => (
  <img
    src={inverted ? "/logos/logo-icon-white.png" : "/logos/logo-icon-dark.png"}
    alt=""
    aria-hidden="true"
    className="h-8 w-auto shrink-0 opacity-80"
    draggable={false}
  />
);

const Row = ({ inverted }) => (
  <div className="flex items-center gap-12 lg:gap-16 px-8 shrink-0">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center gap-12 lg:gap-16 shrink-0">
        <span className={`font-serif italic text-4xl sm:text-5xl lg:text-6xl whitespace-nowrap font-normal ${inverted ? "text-white" : "text-charcoal"}`}>
          {item}
        </span>
        <HouseGlyph inverted={inverted} />
      </span>
    ))}
  </div>
);

export const Marquee = ({ inverted = false }) => {
  return (
    <div
      data-testid="marquee"
      className={`relative overflow-hidden border-y ${
        inverted
          ? "bg-charcoal-deep border-white/10 text-white"
          : "bg-cream border-border text-charcoal"
      } py-8 lg:py-12`}
    >
      <div className="flex animate-[marquee_38s_linear_infinite] w-max">
        <Row inverted={inverted} />
        <Row inverted={inverted} />
        <Row inverted={inverted} />
      </div>
      <style>{`
        @keyframes marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-33.333%); }
        }
        @media (prefers-reduced-motion: reduce) {
          [data-testid="marquee"] > div { animation: none !important; }
        }
      `}</style>
    </div>
  );
};
